import React from 'react';

const CookiePolicy = () => {
  return (
    <div>
      <h2>Cookie Policy</h2>
      <p>This is the content of the cookie policy page.</p>
    </div>
  );
};

export default CookiePolicy;
